"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetailsHeader = void 0;
var Utilities_1 = require("../../Utilities");
var DetailsHeader_base_1 = require("./DetailsHeader.base");
var DetailsHeader_styles_1 = require("./DetailsHeader.styles");
exports.DetailsHeader = Utilities_1.styled(DetailsHeader_base_1.DetailsHeaderBase, DetailsHeader_styles_1.getDetailsHeaderStyles, undefined, { scope: 'DetailsHeader' });
//# sourceMappingURL=DetailsHeader.js.map